import { Component, Input } from '@angular/core';

import { MenuComponent } from '../menu.component';

@Component({
  selector: 'customer-menu-item',
  templateUrl: './menu-item.component.html',
  styles: [],
})
export class MenuItemComponent<T> {
  @Input() value?: T;

  _tooltipText?: string;
  @Input() set tooltipText(value: string | undefined) {
    this._tooltipText = value?.toUpperCase();
  }

  @Input() withAction = true;

  get active(): boolean {
    return this.value === this.menu.value;
  }

  constructor(readonly menu: MenuComponent<T>) { }

  click(): void {
    if (!this.withAction) {
      return;
    }

    this.activate();
  }

  activate(): void {
    this.menu.value = this.value;
    this.menu.valueChange.emit(this.value);
  }
}
